import config from 'appConfig';
import datetime from 'lib/datetime';
import { VALIDITY_DATE_FORMAT } from './constants';
import { Perk, UserUnlockedReward } from './types';

export const isUpcoming = (startedAt: Date | null): boolean => {
  if (!startedAt) return false;

  const start = datetime(startedAt).tz(config.timezone);
  const now = datetime().tz(config.timezone);

  return !start.isBefore(now, 'second');
};

export const isExpired = (expiredAt?: Date | null): boolean => {
  if (!expiredAt) return false;

  const now = datetime().tz(config.timezone);
  const expiredDate = datetime(expiredAt).tz(config.timezone);

  return now.isAfter(expiredDate, 'second');
};

export const formatValidityDate = (
  date: Date | null,
): string | null => {
  if (!date) return null;

  return datetime(date)
    .tz(config.timezone)
    .format(VALIDITY_DATE_FORMAT);
};

export const isFullyRedeemed = (
  quota: number | null,
  totalRedeem: number,
): boolean => {
  if (!quota) return false;

  return quota === totalRedeem;
};

export const mapRewardsToPerks = (
  rewards: UserUnlockedReward[],
): Perk[] => {
  return rewards.map((unlocked) => {
    const perk = unlocked.reward.perk;
    const reward = unlocked.reward;

    return {
      ...perk,
      progress: {
        step: perk.progress?.step ?? 0,
        is_unlockable: true,
        unlocked_reward: {
          id: reward.id,
          reward: {
            ...reward,
          },
          unlocked_at: unlocked.unlocked_at,
          redeemed_at: unlocked.redeemed_at,
          expired_at: unlocked.expired_at,
        },
      },
    };
  });
};
